import externalGetFetcher from 'api/utils/externalGetFetcher';
import useSWR from 'swr';

interface Page {
  id: string;
  name: string;
  url: string;
  time_zone: string;
  updated_at: string;
}

interface Component {
  id: string;
  name: string;
  status: string;
  created_at: string;
  updated_at: string;
  position: number;
  description: string | null;
  showcase: boolean;
  start_date: string;
  group_id: string | null;
  page_id: string;
  group: boolean;
  only_show_if_degraded: boolean;
}

interface Incident {
  id: string;
  name: string;
  status: string;
  created_at: string;
  updated_at: string;
  monitoring_at: string | null;
  resolved_at: string | null;
  impact: string;
  shortlink: string;
  started_at: string;
  page_id: string;
  incident_updates: Array<IncidentUpdate>;
  components: Array<Component>;
  reminder_intervals: string;
}

interface IncidentUpdate {
  id: string;
  status: string;
  body: string;
  incident_id: string;
  created_at: string;
  updated_at: string;
  display_at: string;
  affected_components: Array<AffectedComponent>;
  deliver_notifications: boolean;
  custom_tweet: string | null;
  tweet_id: string | null;
}

interface AffectedComponent {
  code: string;
  name: string;
  old_status: string;
  new_status: string;
}

interface ScheduledMaintenance {
  id: string;
  name: string;
  status: string;
  created_at: string;
  updated_at: string;
  monitoring_at: string | null;
  resolved_at: string | null;
  impact: string;
  shortlink: string;
  started_at: string;
  page_id: string;
  incident_updates: Array<IncidentUpdate>;
  components: Array<Component>;
  scheduled_for: string;
  scheduled_until: string;
}

interface Status {
  indicator: string;
  description: string;
}

export interface StatusPageSummaryResult {
  page: Page;
  components: Array<Component>;
  incidents: Array<Incident>;
  scheduled_maintenances: Array<ScheduledMaintenance>;
  status: Status;
}

export interface StatusPageError {}

const url = `${process.env.VITE_STATUSPAGE_URL}/api/v2/summary.json`;

const useStatusPage = () => {
  const { data, error, isLoading, mutate, isValidating } = useSWR<
    StatusPageSummaryResult,
    StatusPageError
  >(url, externalGetFetcher);

  return {
    status: data,
    error,
    isLoading,
    mutate,
    isValidating,
  };
};

export default useStatusPage;
